import { FC } from 'react';
import { Skeleton, SkeletonProps } from '@mui/material';

type Props = {
  rows: number;
} & SkeletonProps;
export const TableLoader: FC<Props> = ({ rows, ...rest }) =>
  Array.from({ length: rows }, (_, i) => i + 1).map((key) => <Skeleton key={key} {...rest} />);
